export default __webpack_public_path__ + "static/media/import_icon.ae11ce0c.png";